module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Thin.85741cd.ttf";